import type { ReactNode } from 'react';

export const symbol_align_horizontal_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M109.82-80Q97-80 88.5-88.63 80-97.25 80-110v-740q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v740q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63ZM290-290q-20.83 0-35.42-14.62Q240-319.24 240-340.12q0-20.88 14.58-35.38Q269.17-390 290-390h300q20.83 0 35.42 14.62Q640-360.76 640-339.88q0 20.88-14.58 35.38Q610.83-290 590-290H290Zm0-280q-20.83 0-35.42-14.62Q240-599.24 240-620.12q0-20.88 14.58-35.38Q269.17-670 290-670h540q20.83 0 35.42 14.62Q880-640.76 880-619.88q0 20.88-14.58 35.38Q850.83-570 830-570H290Z"
		/>
	</svg>
);
